import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { User } from '../../shared/entities/user';
import { MsalService } from '@azure/msal-angular';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, ToastrModule],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {

  user: User = {};
  profileForm!: FormGroup;

  constructor(private authService: AuthService,
    private msal: MsalService,
    private fb: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService) {

  }

  ngOnInit(): void {
    this.user = this.authService.loggedInUser();
    this.profileForm = this.fb.group({
      firstName: [this.user.firstName, [Validators.required]],
      lastName: [this.user.lastName, [Validators.required]],
      phone: [this.user.phoneNumber, [Validators.required]]
    })
    if (Object.keys(this.user).length === 0) {
      this.userService.getProfile().subscribe((res: any) => {
        this.user = res;
        this.profileForm = this.fb.group({
          firstName: [this.user.firstName, [Validators.required]],
          lastName: [this.user.lastName, [Validators.required]],
          phone: [this.user.phoneNumber, [Validators.required]]
        })
      })
    }
  }

  get firstName() {
    return this.profileForm.get('firstName')
  }

  get lastName() {
    return this.profileForm.get('lastName')
  }
  get phone() {
    return this.profileForm.get('phone')
  }

  get fullName() {
    const userData = this.authService.loggedInUser();

    let uname: string | undefined = '';

    if (userData.firstName && userData.lastName) {
      uname = userData.firstName + ' ' + userData.lastName;
    } else {
      if (this.msal.instance.getActiveAccount()) {
        uname = this.msal.instance.getActiveAccount()?.username;
        if (uname) {
          uname = uname?.substring(0, uname.indexOf('@'));
        } else {
          console.log("")
        }
      }

    }

    return uname;
  }

  onProfileSubmit() {
    const userData = this.authService.loggedInUser();

    userData.firstName = this.profileForm.value.firstName;
    userData.lastName = this.profileForm.value.lastName;
    userData.phoneNumber = this.profileForm.value.phone;


    if (userData?.id) {
      this.userService.updateProfile(userData?.id, userData).subscribe({
        next: () => {
          this.toastr.success('Profile Updated')
        }, error: error => {
        }
      });
    }
  }

}
